<template>
    <el-form
        v-bind="$attrs"
        label-width="120px"
        label-position="top"
        :model="value"
        :rules="rules"
        ref="form"
    >
        <el-form-item v-if="address && isLatestAddressDifferent && editable">
            <el-button @click="applyLatestaddress" type="secondary" size="small">{{
                $t('Update Address Using Coordinates')
            }}</el-button>
        </el-form-item>

        <el-form-item :label="$t('Address Line 1')" prop="street1">
            <el-input
                v-if="editable"
                :placeholder="$t('Address Line 1')"
                v-model="value.street1"
                size="small"
                class="w-100"
            />
            <span v-else>{{ value.street1 }}</span>
        </el-form-item>
        <el-form-item :label="$t('Address Line 2')">
            <el-input
                v-if="editable"
                :placeholder="$t('Address Line 2')"
                v-model="value.street2"
                size="small"
                class="w-100"
            />
            <span v-else>{{ value.street2 }}</span>
        </el-form-item>
        <el-row :gutter="10">
            <el-col :span="12">
                <el-form-item :label="$t('Country')" prop="country">
                    <el-input
                        v-if="editable"
                        :placeholder="$t('Country')"
                        v-model="value.country"
                        size="small"
                        class="w-100"
                    />
                    <span v-else>{{ value.country }}</span>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('City')" prop="city">
                    <el-input
                        v-if="editable"
                        :placeholder="$t('City')"
                        v-model="value.city"
                        size="small"
                        class="w-100"
                    />
                    <span v-else>{{ value.city }}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="12">
                <el-form-item :label="$t('District')" prop="district">
                    <el-input
                        v-if="editable"
                        :placeholder="$t('District')"
                        v-model="value.district"
                        size="small"
                        class="w-100"
                    />
                    <span v-else>{{ value.district }}</span>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('Postal Code')">
                    <el-input
                        v-if="editable"
                        :placeholder="$t('Postal Code')"
                        v-model="value.postal_code"
                        size="small"
                        class="w-100"
                    />
                    <span v-else>{{ value.postal_code }}</span>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
export default {
    name: 'addressform',
    props: {
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        address: {
            type: Object,
            default() {
                return {};
            },
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        const required = !!this.editable;

        return {
            rules: {
                street1: [
                    {
                        required,
                        message: this.$t('Please enter address line'),
                        trigger: 'blur',
                    },
                ],
                country: [
                    {
                        required,
                        message: this.$t('Please enter country'),
                        trigger: 'blur',
                    },
                ],
                city: [
                    {
                        required,
                        message: this.$t('Please enter city'),
                        trigger: 'blur',
                    },
                ],
                district: [
                    {
                        required,
                        message: this.$t('Please enter district'),
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isLatestAddressDifferent() {
            return (
                !this.address ||
                this.value.street1 !== this.address.street1 ||
                this.value.street2 !== this.address.street2 ||
                this.value.country !== this.address.country ||
                this.value.city !== this.address.city ||
                this.value.district !== this.address.district ||
                this.value.postal_code !== this.address.postal_code ||
                this.value.address_text !== this.address.address_text
            );
        },
        isRSA() {
            return this.$store.getters.isRSA;
        },
    },
    methods: {
        applyLatestaddress() {
            if (this.address) {
                Object.assign(this.value, this.address);
            }
        },
        validate(cb) {
            return this.$refs.form.validate(cb);
        },
        clearValidate() {
            return this.$refs.form.clearValidate();
        },
    },
};
</script>

<style lang="scss"></style>
